import React, { useState, useEffect } from 'react';
import Select from "web/components/form-elements/Select";
import AlertModal from 'web/components/AlertModal';
import { useDispatch } from "react-redux";
import {
    referenceNumberList,
  } from "redux/actions/adminPtPlus";

const ReferenceNumberList = (props) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = '';

  useEffect(() => {
    referenceNumberListAPI()
   }, []);

  let obj=[
    {
        label:"",
        value:""
    }
  ]
  const [referenceNumberListState, setReferenceNumberListState] = useState(obj)
  const referenceNumberListAPI = async () => {

    // when need is prefilled from ptplus pending request, this order id is also appeneded
    
    let ptplusOrderRefObj
    if(props.editResponse?.editType === 'ptplusorder' || (props.editResponse?.plusDetails?.orderRefNumber && props.editResponse?.plusDetails?.orderRefNumber !== '')) {
      ptplusOrderRefObj = {
        label : props.editResponse?.plusDetails?.orderRefNumber,
        value: props.editResponse?.plusDetails?.orderRefNumber
      }
    }else{
      if(props.response?.payload?.postLoad?.orderRefNumber){
        ptplusOrderRefObj = {
          label : props.response?.payload?.postLoad?.orderRefNumber,
          value: props.response?.payload?.postLoad?.orderRefNumber
        }
      }     
    }

    const response = await dispatch(referenceNumberList(token));
    if (response?.success) {
        let arr =[]       
        for(let i=0;i<response?.data?.length; i++){
            let obj =
            {
                label:response?.data[i],
                value:response?.data[i]
            } 
            arr.push(obj)

            if(response?.data?.length-1 === i){
                if(ptplusOrderRefObj) arr.push(ptplusOrderRefObj)
                setReferenceNumberListState(arr)
            }
        }
    } else {
        let arr =[] 
        if(ptplusOrderRefObj) arr.push(ptplusOrderRefObj)
        setReferenceNumberListState(arr)
    //   setModalContent(response?.data?.error?.message);
    //   setModalLink("");
    //   toggleModal();
    }
  };

  return (
    <div>
      <Select
        name="referenceNumber"
        data={referenceNumberListState}
        placeholder="Reference Number"
        disabled={props.disabled}
        onChangeHandler={(data) => {
        }}
        />
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};
export default ReferenceNumberList;
